import React from 'react';
import CalendarDay from './components/CalendarDay';
import './styles.css';

const CalendarGroup = props => {
  const { duration, schedule, actions } = props;
  return (
    <div className="calendar-group">
      {schedule.map(day => (
        <CalendarDay
          data={day}
          duration={duration}
          actions={actions}
          key={day.Dow}
        />
      ))}
    </div>
  );
};

export default CalendarGroup;
